export default __webpack_public_path__ + "static/media/2025.6fdfb9bc.png";